const envApiBase = (process.env.REACT_APP_API_BASE || "").trim();

const inferApiBase = () => {
  if (typeof window === "undefined") return "http://127.0.0.1:8000/api";
  const host = String(window.location.hostname || "").toLowerCase();

  // Production website -> production API
  if (host === "backupjo.com" || host === "www.backupjo.com") {
    return "https://backupjo-admin.com/api";
  }

  // Local/dev default
  return "http://127.0.0.1:8000/api";
};

export const API_BASE = envApiBase || inferApiBase();
